<script lang="ts">
    import { afterUpdate } from "svelte";
    import { appManager } from "../../AppManager";
    import { _ } from "svelte-i18n";
    import { ModalHook } from "../../shared/modals/ModalHook";
    import type { OdEditModalData } from "./OdEditModalData";
    import { OdEditModalManager } from "./OdEditModalManager";
    import OdMatrixValues from "./OdMatrixValues.svelte";
    import {Utils} from "../../Utils";

    let hook: ModalHook<OdEditModalData, "cancelled" | "saved"> = new ModalHook<
        OdEditModalData,
        "cancelled" | "saved"
    >();
    appManager.ModalHooks.OdEditModal = hook;

    let open: boolean = false;
    let manager: OdEditModalManager;
    let mapContainer: HTMLElement;

    // hook events.
    hook.on("open", () => {
        const openData = hook.getData();
        manager = new OdEditModalManager(openData);

        open = true;
    });
    hook.on("close", () => {
        open = false;
    });

    const close = () => {
        hook.close("cancelled");
    };

    const save = async () => {
        hook.close("saved");
    };

    function download(): void {
        const csv = manager.getAsCSV();

        new Utils().offerContentsAsDownloadableFile(
            csv,
            "matrix.csv",
            {
                mimetype: "text/csv",
            },
        );
    }
    
    afterUpdate(async () => {
        if (open) {
            await manager.initializeMap(mapContainer);
        }
    });
</script>

{#if open}
    <div class="modal show" style="display: block;">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title h4">
                        {$_("impact.scenario.editmatrix.title")}
                    </div>
                    <button
                        type="button"
                        class="btn-close btn-lg btn-close-lg"
                        aria-label="Close"
                        on:click={close} />
                </div>
                <div class="modal-body p-0 mh-100">
                    <div class="container-fluid p-0 h-100 mh-100">
                        <div class="row g-0 h-100">
                            <div class="col-6">
                                <div class="map w-100 h-100">
                                    <div
                                        class="w-100 h-100"
                                        bind:this={mapContainer}>
                                        <slot />
                                    </div>
                                </div>
                            </div>
                            <div
                                class="col-6 mh-100"
                                style="overflow-y: scroll;">
                                <OdMatrixValues {manager} />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button
                            type="button"
                            class="btn btn-light"
                            data-bs-dismiss="modal"
                            on:click={download}
                    >{$_("impact.scenario.editmatrix.download")}
                    </button>
                    <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                        on:click={save}
                        >{$_("impact.scenario.editmatrix.save")}
                    </button>
                </div>
            </div>
        </div>
    </div>
{/if}

<style>
    .map {
        border-radius: 0.5rem;
        position: relative;
        bottom: 0px;
        left: 0px;
        right: 0px;
    }

    .modal {
        display: block;
    }

    .table {
        table-layout: fixed;
    }

    .header th {
        width: 35px;
    }
</style>
